export default __webpack_public_path__ + "static/media/questions-bg.3e66581a.jpg";